import { LoadingButton } from "@mui/lab";
import { Paper, Stack, Typography } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player/lazy";
import { useDispatch, useSelector } from "react-redux";
import { deleteVideoAllocationThunk } from "store/reducers/advertisement/adsVideoAllocationSlice";
import addURLPrefix from "utils/addURLPrefix";

const AdVidsInMachineItem = ({ item }) => {
  const dispatch = useDispatch();
  const deleteItem = () => {
    dispatch(deleteVideoAllocationThunk(item.id));
  };
  const { loading } = useSelector((state) => state.adsVideoAllocation);
  return (
    <Paper>
      <ReactPlayer
        width="100%"
        height={200}
        url={addURLPrefix(item.video_link)}
        controls={true}
        light={false}
      />
      <Typography sx={{ mt: 1, ml: 2, color: "text.secondary" }} variant="h6">
        Location : {item.title}
      </Typography>
      <Stack alignItems="center" direction="column" alignContent="s">
        <LoadingButton
          loading={loading?.delete === item.id}
          variant="outlined"
          color="error"
          sx={{ margin: 1 }}
          onClick={deleteItem}
        >
          Remove
        </LoadingButton>
      </Stack>
    </Paper>
  );
};

export default AdVidsInMachineItem;
